/* eslint-disable max-len */
import React from 'react';

const CodeBlockIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19">
    <path
      fillRule="evenodd"
      d="M2 3h15a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 1v11h15V4H2zm12.8 9H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2zm-10.542.25a.2.2 0 0 1-.282 0l-.425-.425a.2.2 0 0 1 0-.283l3.041-3.041-3.04-3.04a.2.2 0 0 1 0-.283l.424-.425a.2.2 0 0 1 .283 0l3.606 3.606a.2.2 0 0 1 0 .283l-3.607 3.607z"
    />
  </svg>
);

export default CodeBlockIcon;
